export default class MobileMenu {
    constructor($el) {
        this.$el = $el;
        this.$hamburger = this.$el.querySelector('[data-hamburger]');
        this.$menu = this.$el.querySelector('[data-header-menu]');
        this.onResize = this.onResize.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        if (!this.$hamburger || !this.$menu) {
            return;
        }

        this.$hamburger.addEventListener('click', this.toggleMenu);
        window.addEventListener('resize', this.onResize, {passive: true});
    }

    toggleMenu(e) {
        e.preventDefault();

        const isOpen = this.$hamburger.classList.toggle('hamburger--open');
        this.$menu.classList.toggle('header__menu--open', isOpen);
        document.body.classList.toggle('menu-open', isOpen);
    }

    onResize() {
        if (window.matchMedia('(min-width: 1400px)').matches) {
            this.$hamburger.classList.remove('hamburger--open');
            this.$menu.classList.remove('header__menu--open');
            document.body.classList.remove('menu-open');
        }
    }
}
